import "../../../../../@vanilla-extract/webpack-plugin/vanilla.virtual.css?%7B%22fileName%22%3A%22..%2F..%2Fnode_modules%2F%40faire%2Fweb%2Fslate-labs%2FCarousel%2F__internal__%2FcarouselStyles.css.ts.vanilla.css%22%2C%22source%22%3A%22%23H4sIAAAAAAAAA8WT7W7aMBSG%2F3MVR5oqxe3cxXzXlabdyWRiQ9w6dpZ4EDr13qeYUJI4lIBANRLyx3ten3P85PE3mYfDlzhZw0%2FgsvzP1yv4NwDIbWZeBYU1ywKM97oQPQ8AIqNM1nX0PnhsOdLYrEV20pcc9yUtX8plzhZK8KMpf5tNyl%2FN8WOnZrR1MRvJbUyBhOFdqU9NLq00mkImFLNyLRoxJHRBZUlLZTYUYsm50GVkLOQqtnunegxxMcfPh%2B48kRpXyYTN81H7PGEFjoy2QttS%2BSsRXDLIo0wIDUxzCGri2XSeFgicR%2B1xymW9XLbIjfprxbPbtyalMNm1BOANS81FQYGU6%2Fe60aYyUmJpXeIuOmM6X5osobupYlYEEVNREJTVw0PrhYcIwT1ggr4DnoR3yLulqG7Jdi08ec2xWxr%2B3Y1jxaFxM79x233jGOdSr%2FCubjJNCy%2Fpt0rKZZ4qtqWwVKLYZc6UXGksrUhyCpHQVmReeIUFuDAKIYTganN75TjMyuFKxo2ttqQczZYwBPeepCvMD50iwEDgoVPaFieop%2FAP6pC19%2BprBD9qq2biTWuBPCKkn1a7yPpV1dzHk4yrp0pYtpIaV5i2e%2F0Zdt732qaRhMORj6MPSZXk1VF5uhyVyTmoqL6opLdDhfuoxKdQmfRFhWpjA6pYbnEUS8VRD3aeOo0OHp0WDgH%2FEVvWFvXkkoTD8VcCOL8cwPE5AL72BdDcDsDIB3B1CsDxLQGcXwnAuQ9g3hvA8Tj8SgBnlwM4OgfAl74A6tsBuPABXJ4CcHRLAGdXAnDmA5h9APgfGAeMEA4NAAA%3D%22%7D"
export var carouselWrapperStyles = '_1802jhmy';
export var iconButtonSyles = '_1802jhmv';
export var innerContainerStyles = '_1802jhm11';
export var nextButtonStyles = '_1802jhmx';
export var outerContainerStyles = '_1802jhm10';
export var previousButtonStyles = '_1802jhmw';
export var showArrowButtonsStyles = '_1802jhmz';
export var slideStylesGap = '_1802jhm14';
export var slideStylesWidthFixed = '_1802jhm12';
export var slideStylesWidthFreeFlow = '_1802jhm13';
export var varArrowColor = 'var(--_1802jhm0)';
export var varArrowColorHover = 'var(--_1802jhm1)';
export var varArrowOffsetX = 'var(--_1802jhm2)';
export var varHasPeekNextDesktop = 'var(--_1802jhmk)';
export var varHasPeekNextMobile = 'var(--_1802jhmm)';
export var varHasPeekNextTablet = 'var(--_1802jhml)';
export var varHasPeekNextXLarge = 'var(--_1802jhmj)';
export var varHasPeekPreviousDesktop = 'var(--_1802jhmo)';
export var varHasPeekPreviousMobile = 'var(--_1802jhmq)';
export var varHasPeekPreviousTablet = 'var(--_1802jhmp)';
export var varHasPeekPreviousXLarge = 'var(--_1802jhmn)';
export var varItemGapDesktop = 'var(--_1802jhm8)';
export var varItemGapMobile = 'var(--_1802jhma)';
export var varItemGapTablet = 'var(--_1802jhm9)';
export var varItemGapXLarge = 'var(--_1802jhm7)';
export var varItemPerSlideDesktop = 'var(--_1802jhm4)';
export var varItemPerSlideMobile = 'var(--_1802jhm6)';
export var varItemPerSlideTablet = 'var(--_1802jhm5)';
export var varItemPerSlideXLarge = 'var(--_1802jhm3)';
export var varLoopDesktop = 'var(--_1802jhms)';
export var varLoopMobile = 'var(--_1802jhmu)';
export var varLoopTablet = 'var(--_1802jhmt)';
export var varLoopXLarge = 'var(--_1802jhmr)';
export var varPeekNextDesktop = 'var(--_1802jhmc)';
export var varPeekNextMobile = 'var(--_1802jhme)';
export var varPeekNextTablet = 'var(--_1802jhmd)';
export var varPeekNextXLarge = 'var(--_1802jhmb)';
export var varPeekPreviousDesktop = 'var(--_1802jhmg)';
export var varPeekPreviousMobile = 'var(--_1802jhmi)';
export var varPeekPreviousTablet = 'var(--_1802jhmh)';
export var varPeekPreviousXLarge = 'var(--_1802jhmf)';